import { EAppNameEnum, TAppNameEnum } from '@onesource/schemas';
import membersAxios from '../../members/axios';
import commonAxios from '../axios';

export const getAxiosForApp = (appName: TAppNameEnum) => {
  if (appName === EAppNameEnum.MEMBERS) {
    return membersAxios;
  }
  return commonAxios;
};
